const dateUtils = {
    formatDate: (date: Date) => {
        return date?.toLocaleTimeString([], { year: 'numeric', month: 'short', day: 'numeric', hour: '2-digit', minute: '2-digit' }).replace('.', '');
    }

}

export default dateUtils;